export const SET_MENU = '@customization/MENU_OPEN';
export const SET_INVESTOR_DETAILS = '@customization/SET_INVESTOR_DETAILS';
export const SET_ROLE_DETAILS = '@customization/SET_ROLE_DETAILS';
export const SET_PERMISSION_TEMPLATE = '@customization/SET_PERMISSION_TEMPLATE';
export const SET_USER_ACCESS = '@customization/SET_USER_ACCESS';
export const RESET_STATE = 'RESET_STATE';
export const SET_INVESTOR_TYPES = '@customization/SET_INVESTOR_TYPES';
export const SET_PROGRESS_DATA = '@customization/SET_PROGRESS_DATA';